import { get as getPageOptions } from '../01-helpers/utilities/options';

export default class ApproveScorecard {
    constructor(approvalForm) {
        this.$form = $(approvalForm);

        this.$approve = this.$form.find('.js-scorecard-approve');
        this.$reject = this.$form.find('.js-scorecard-reject');

        this.data = getPageOptions('scorecard');


        if (this.$form.length) {
            this.bindEvents();
        }
    }

    onSubmitHandler(e) {
        let action = '';
        switch (e.originalEvent.submitter.value) {
            case 'Accept':
                action = 'approved'
                break;
            case 'Decline': 
                action = 'declined'
                break;
            
        }
        dataLayer.push({
            'event': `scorecard_${action}`,
            'course': this.data.CourseName,
            'holes': this.data.LoopName,
            'tee': this.data.TeeName,
            'Qualifying': this.data.IsQualifying,
            'eventCategory': 'scoreCard',
            'eventAction': 'check',
            'eventLabel': action,
        });
    }

    /**
     * Initializes the event handlers
     */

    bindEvents() {
        this.$form.on('submit', (e) => this.onSubmitHandler(e));
        this.$reject.on('click', (e) => this.reject(e));
        this.$approve.on('click', (e) => this.approve(e));
    }

    reject(e) {
        if (!confirm(this.$reject.attr('data-reject-text'))) {
            e.preventDefault();
        }
        
    }

    approve(e) {
        if (!confirm(this.$approve.attr('data-approve-text'))) {
            e.preventDefault();
        }
    }
}
